import UtilsSet from "../../../gd/utils/set";
import {ConstMyWorkViews, ConstToolsViews} from "../../../gd/const/setup/setup-views";

const debug = {
    dev: false,
    head: "CompanySettingsSetup"
}

const defaultDisabledViews = {
    manager: [],
    user: [
        "tools.resource-planning",
        "tools.gantt-all-projects",
        "tools.whats-done",
        "tools.tasks-by-user",
        "projects.portfolio"
    ],
    guest: [
        "tools.events-summary",
        "tools.pastdue",
        "projects.portfolio",
        "tools.whats-done",
        "tools.tasks-by-user",
        "tools.board-all-tasks",
        "tools.calendar-vacations",
        "tools.resource-planning",
        "tools.gantt-all-projects"
    ]
}

export default class CompanySettingsSetup {

    public disabledViews        : any = {}

    constructor(data:any) {

        debug.dev && console.log(debug.head,'.constructor', data);


        this._init(data);

        debug.dev && console.log(debug.head,'.constructor - done', this);
    }

    _init(data:any) {

        debug.dev && console.log(debug.head,'.init', data);


        // see import {ConstToolsViews, ConstMyWorkViews} from 'core/gd/const/setup/setup-views'
        this.disabledViews = {
            // @ts-ignore
            manager     : new Set(_.get(data,'disabledViews.manager',defaultDisabledViews.manager)),
            user        : new Set(_.get(data,'disabledViews.user',defaultDisabledViews.user)),
            guest       : new Set(_.get(data,'disabledViews.guest',defaultDisabledViews.guest))
        }

    }

    getSetupViews(role:any) {
        // @ts-ignore
        const allViews = new Set([].concat(ConstMyWorkViews).concat(ConstToolsViews))
        const disabledViews = this.disabledViews[role];

        return UtilsSet.difference(allViews, disabledViews);
    }

    toJSON() {

        const disabledViews = {
            manager: [...this.disabledViews.manager],
            user: [...this.disabledViews.user],
            guest: [...this.disabledViews.guest],
        }

        return {
            disabledViews:  (disabledViews!==defaultDisabledViews)?disabledViews:null
        }
    }
}
